import { FormEvent, useEffect } from 'react'
import { GetServerSideProps } from 'next'
import { useRouter } from 'next/router'
import Image from 'next/image'
import { getSession, signIn } from 'next-auth/react'
import { toast } from 'react-hot-toast'

import { AuthLayout } from '../../../layouts'
import { Button } from '../../../components'
import { useForm } from '../../../hooks'

const LoginPage = ({error}: {error:string | null}) => {
  const { password, email, onInputChange } = useForm({ email: '', password: '' })

  const router = useRouter()
  const redirect = router.query.redirect?.toString()

  useEffect(() => {
    if( error ) {
      toast.error('Fallo la autenticación: Error en las credenciales')
    }
  }, [error])

  const onLogin = async (e:FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if( [email, password].some( value => value === '') ) return

    try {
      await signIn('credentials', { email, password })

    } catch(error) {
      console.log(error)
      if( typeof error === 'string' ) {
        toast.error(error)
      }
    }
  }

  const onGoogleSignin = () => {
    try {
      signIn('google',)
    } catch(error) {
      toast.error((error as string))
    }
  }

  return (
    <AuthLayout
      pageTitle='Login | Dartmong'
      subtitle='Inicia sesión con tu cuenta'
    >
      <form onSubmit={ onLogin }>
        <label htmlFor="email">
          <input
            type="email"
            name="email"
            id="email"
            placeholder='Correo Electrónico'
            value={ email }
            onChange={ onInputChange }
            required
          />
        </label>
        <label htmlFor="password">
          <input
            type="password"
            name="password"
            id="password"
            placeholder='Contraseña'
            value={ password }
            onChange={ onInputChange }
            required
          />
        </label>
        <Button
          label='Entrar'
          color='white'
          style={{
            backgroundImage: 'var(--primary-gradient)',
          }}
        />
      </form>

      <footer>
        <p className='big-text'>También puedes iniciar sesión con:</p>
        <Image
          src="/icons/google.svg"
          alt='Google Icon'
          layout='fixed'
          width={48}
          height={48}
          onClick={ () => onGoogleSignin() }
        />
        <Button
          label='Crear una cuenta'
          color='white'
          fullWidth
          onClick={ () => router.push(redirect ? `/auth/register?redirect=${redirect}` : '/auth/register' )}
          style={{
            backgroundImage: 'var(--primary-gradient)',
          }}
        />
      </footer>
    </AuthLayout>
  )
}

export default LoginPage

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const session = await getSession({req: ctx.req})

  if( session ) {
    return {
      redirect: {
        destination: '/profile',
        permanent: false
      }
    }
  }

  const error = ctx.query.error?.toString() 

  return {
    props: {
      error: error || null
    }
  }
}
